import React from 'react';
import './DesktopNav.scss';

const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;

/**
 * Render the desktop navigation
 * @param {String} classes - Additional class names to include
 * @param {Function} onClickAction - Function reference to the function that execute when a child menu item is clicked
 * @param {Array} linkItems - Children menu items
 * @param {MutableRefObject} drawer - Reference to the drawer menu
 * @param {Array} menuItems - Parent menu items
 * @returns {JSX.Element}
 * @constructor
 */
const DesktopNav = ({ classes, onClickAction, linkItems, drawer, menuItems }) => (
  <div className="c-desktop-nav">
    <ul className="c-desktop-nav__list">
      {linkItems.map((link, i) => (
        <li
          key={i}
          className={`c-desktop-nav__list-item ${
            menuItems[i].isExpanded ? 'active' : ''
          } ${classes}`}
          onClick={() => {
            onClickAction(i);
            disableBodyScroll(drawer);
          }}
        >
          {link}
        </li>
      ))}
    </ul>
  </div>
);

export default DesktopNav;
